import ResponsiveImage from '~/components/Image/ResponsiveImage'

const GlobeAi = ({ isSmall, hideCircle }: { isSmall?: boolean; hideCircle?: boolean }): React.ReactElement => {
  return (
    <div className="relative">
      <div
        className={`flex justify-center items-center overflow-hidden ${
          hideCircle ? '' : 'bg-gradient-purple-dark border-2 border-purple rounded-full'
        } ${isSmall ? 'w-9 md:w-12 h-9 md:h-12' : 'w-17 h-17 md:h-25 md:w-25'}`}
      >
        <ResponsiveImage srcKey="landing/ask-the-oracle.png" />
      </div>
    </div>
  )
}

export default GlobeAi
